<template>
  <div class="fccRelatorios">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :status="status"
            :actions="actions"
            addFilter
            :items="listagemRelatorio"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="editFieldModal"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
      size="lg"
    >
      <form
        @submit.prevent="editar.objid === 0 ? criarRelatorio() : editarRelatorio()"
        autocomplete="off"
      >
        <div class="my-2">
          <div class="row">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" v-model="editar.objnome" required>Nome</fccInput>
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" v-model="editar.objdescricao" required
                >Descrição</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <fccInput
                extraClasses="inputLabel"
                v-model="editar.objview"
                @change="listandoCampos(editar.objview)"
                required
                >View</fccInput
              >
              <span class="fontSize12"
                >A view deverá já estar criada no banco de dados "relatórios"</span
              >
            </div>
          </div>
          <div v-if="listarCamposObrigatorios.length > 0">
            <div class="row innerPage">
              <div class="col-sm-12">
                <span class="titlePage sub">Configurações de Campos</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <span
                  >Informe abaixo a quantidade mínima de caracteres para tornar o campo obrigatório
                  para a consulta. <br />
                  Se o campo não for obrigatório, mantenha zero (0).</span
                >
              </div>
            </div>
            <div class="row mt-3">
              <div
                class="col-sm-6 mt-3"
                v-for="listaCampo in listarCamposObrigatorios"
                :key="listaCampo.columnname"
              >
                <div class="row">
                  <div class="col-8">
                    {{ listaCampo.columnname.toUpperCase() }}
                    <input
                      type="number"
                      @input="filtroBusca"
                      class="inputLabel"
                      v-model="listaCampo.tamminimo"
                      required
                    />
                  </div>

                  <div
                    class="col-4 text-center"
                    v-if="listaInt.indexOf(listaCampo.datatype) !== -1"
                  >
                    Totalizar
                    <div>
                      <toggle-button class="mt-2" v-model="listaCampo.indtotal" :sync="true" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col mt-3">
                <div class="col-sm-6">
                  <label>Ativo</label><br />
                  <toggle-button v-model="editar.objativo" />
                </div>
              </div>
              <div class="col mt-3">
                <div class="col-sm-6">
                  <label>Filtro ao buscar</label><br />
                  <toggle-button
                    v-model="editar.objflfiltrobuscar"
                    :disabled="ativaFiltroBusca"
                    :sync="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row my-4">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Relatórios',
      titlePDF: 'Lista de Relatórios',
      titleModal: '',
      ativaFiltroBusca: false,
      itemPorPage: '100',
      listagemRelatorio: [],
      repositorioSelected: '',
      camposObrigatorios: [],
      baseUrlRelatorios: '',
      alterarRelatorioCadastro: '/Relatorio/AlterarRelatorio',
      excluirRelatorio: '/Relatorio/ExcluirRelatorio',
      inserirRelatorio: '/Relatorio/AdicionarRelatorio',
      listandoTodosRelatorios: '/Relatorio/Relatorios',
      listaInt: [
        'INT',
        'TINYINT',
        'BIT',
        'BIGINT',
        'DECIMAL',
        'NUMERIC',
        'SMALLMONEY',
        'MONEY',
        'FLOAT',
        'REAL'
      ],
      editar: {
        objid: '',
        objhashcode: '',
        objnome: '',
        objdescricao: '',
        objview: '',
        objativo: false,
        objflfiltrobuscar: false
      },
      criar: {
        objid: 0,
        objhashcode: '',
        objnome: '',
        objdescricao: '',
        objview: '',
        objativo: false
      },
      status: [
        {
          funcaoButton: 'changeStatus',
          tooltip: 'Alterar Status',
          campoStatus: 'objativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        },
        {
          button: true,
          funcaoButton: 'permissaoField',
          icon: 'user-cog',
          tooltip: 'Permissão',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fields: [
        { key: 'objnome', label: 'Nome do Relatório', sortable: true, active: true },
        { key: 'objdescricao', label: 'Descrição', sortable: true, active: true },
        { key: 'status', label: 'Status', sortable: true, active: true },
        { key: 'actions', label: '', active: true }
      ]
    }
  },
  methods: {
    filtroBusca() {
      if (this.camposObrigatorios) {
        let filtrandotamminimo = this.camposObrigatorios.filter((item) => item.tamminimo > 0)
        if (!filtrandotamminimo.length) {
          this.ativaFiltroBusca = false
        } else {
          this.ativaFiltroBusca = true
          this.editar.objflfiltrobuscar = true
        }
      }
    },
    listandoCampos: function (view) {
      axios
        .get(
          this.baseUrlRelatorios +
            'Relatorio/ListaComandosRelatorios?view=' +
            view +
            '&objID=' +
            this.editar.objid,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.camposObrigatorios = response.data[0].colunas
          if (this.editar.objid === 0) {
            this.camposObrigatorios = this.camposObrigatorios.map((u) => ({
              ...u,
              indtotal: this.listaInt.indexOf(u.datatype) !== -1
            }))
          }
          this.filtroBusca()
        })
        .catch(this.setErrorSystem)
    },
    changeStatus: function (_, item) {
      this.editar = item
      this.editarRelatorio()
    },
    listandoRelatorios: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlRelatorios + this.listandoTodosRelatorios,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemRelatorio = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.editar = {}
      this.editar.objid = 0
      this.editar.objativo = true
      this.camposObrigatorios = []
      this.titleModal = 'Adicionar cadastro de relatório'
      this.$root.$emit('bv::show::modal', 'editFieldModal')
    },
    permissaoField: function (_, item) {
      this.$router.push({ path: `/relatorioperm/${item.objid}` })
    },
    editField: function (_, item) {
      this.editar = { ...item }
      this.titleModal = 'Editar cadastro de relatório'
      this.listandoCampos(this.editar.objview)
      this.$root.$emit('bv::show::modal', 'editFieldModal')
    },
    deleteField: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.objnome).then(() => {
        axios
          .delete(
            this.baseUrlRelatorios + this.excluirRelatorio + '/' + item.objid,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listandoRelatorios()
            this.callToast(this.mensagensUpdate.excluido)
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      })
    },
    criarRelatorio: function () {
      var objTamanhoCampos = {}
      if (this.listarCamposObrigatorios.length > 0) {
        for (var value of this.listarCamposObrigatorios.values()) {
          objTamanhoCampos[value.columnname] = {
            valor: `${value.tamminimo}`,
            indTotal: value.indtotal
          }
        }
      }
      this.carregaTexto(this.codeMensagem('C03'))
      this.editar.objtamanhocampos = JSON.stringify([objTamanhoCampos])
      axios
        .post(
          this.baseUrlRelatorios + this.inserirRelatorio,
          this.editar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.$root.$emit('bv::hide::modal', 'editFieldModal')
          this.listandoRelatorios()
          this.carregaTexto()
          this.editar = {}
          this.camposObrigatorios = []
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'editFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editarRelatorio: function () {
      var objTamanhoCampos = {}
      if (this.listarCamposObrigatorios.length > 0) {
        for (var value of this.listarCamposObrigatorios.values()) {
          objTamanhoCampos[value.columnname] = {
            valor: `${value.tamminimo}`,
            indTotal: value.indtotal
          }
        }
      }
      this.carregaTexto(this.codeMensagem('C03'))
      this.editar.objtamanhocampos = JSON.stringify([objTamanhoCampos])
      axios
        .put(
          this.baseUrlRelatorios + this.alterarRelatorioCadastro,
          this.editar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoRelatorios()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'editFieldModal')
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'editFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.baseUrlRelatorios = store.state.baseUrlRelatorios
    this.listandoRelatorios()
  },
  computed: {
    listarCamposObrigatorios() {
      return this.camposObrigatorios
    }
  }
}
</script>
